export const FINTECH_SYNCLOG_LOAD_SUCCESS = "FINTECH_SYNCLOG_LOAD_SUCCESS";
export const FINTECH_SYNCLOG_ERROR = "FINTECH_SYNCLOG_ERROR";
export const FINTECH_SYNCLOG_LOADING = "FINTECH_SYNCLOG_LOADING";
export const FINTECH_SYNC_TRIGGERED = "FINTECH_SYNC_TRIGGERED";
